import { copyText } from "./utils";

export function copyWalletAddress(address: string) {
    copyText({
        value: address,
        titleToast: "Wallet address copied",
        descriptionToast: "Your wallet address has been copied to clipboard",
    });
}